



























import { Component, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import getUrlParam from '@/common/utils/getUrlParam';
import PosterMask from '@/components/common/index/PosterMask.vue';

@Component({
  components: {
    'poster-mask': PosterMask,
  }
})
export default class PosterIcon extends Vue {
  @Getter("posterIcon") posterIcon!: string;
  @Getter("showWantDo") showWantDo!: boolean;

  showPosterMask: boolean = false;
  pageType: string = getUrlParam('type') as any;

  hanldeTogglePoster() {
    this.showPosterMask = !this.showPosterMask;
  }
}
